import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Inicio", href: "#inicio" },
  { label: "Atractivos", href: "#atractivos" },
  { label: "Metodología", href: "#metodologia" },
  { label: "Servicios", href: "#servicios" },
  { label: "Testimonios", href: "#testimonios" },
  { label: "Contacto", href: "#contacto" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md border-b border-[#3B3838]/15 shadow-[0_1px_0_rgba(132,60,12,0.15)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#inicio"
          data-testid="navbar-logo"
          className="flex items-center gap-3 group"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_17c8e741-804b-4e75-8d95-781b145a12b3/artifacts/8b00gu4c_Nexora%20PNG.png"
            alt="Nexora Productos"
            className={`h-10 w-10 md:h-12 md:w-12 object-contain transition-all group-hover:rotate-6 ${
              scrolled ? "" : "invert"
            }`}
          />
          <div className="leading-none">
            <div
              className={`font-mono-tech text-[10px] md:text-[11px] tracking-[0.32em] ${
                scrolled ? "text-[#843C0C]" : "text-[#FCD7C5]"
              }`}
            >
              NEXORA
            </div>
            <div
              className={`font-semibold text-sm md:text-base tracking-tight ${
                scrolled ? "text-[#3B3838]" : "text-white"
              }`}
            >
              PRODUCTOS
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={`px-4 py-2 text-sm font-medium transition-colors relative group ${
                scrolled
                  ? "text-[#3B3838] hover:text-[#843C0C]"
                  : "text-white/85 hover:text-white"
              }`}
            >
              {l.label}
              <span className="absolute left-4 right-4 -bottom-0.5 h-px bg-[#843C0C] scale-x-0 group-hover:scale-x-100 origin-left transition-transform" />
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="#contacto"
            data-testid="navbar-cta-contact"
            className="bg-[#203864] hover:bg-[#843C0C] text-white px-5 py-2.5 text-sm font-medium tracking-wide transition-colors copper-glow"
          >
            Cotizar ahora
          </a>
        </div>

        <button
          data-testid="navbar-mobile-toggle"
          onClick={() => setOpen(!open)}
          className={`lg:hidden p-2 ${scrolled ? "text-[#3B3838]" : "text-white"}`}
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-[#3B3838]/15">
          <div className="px-4 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                onClick={() => setOpen(false)}
                className="py-3 px-2 text-[#3B3838] border-b border-[#3B3838]/10 hover:text-[#843C0C]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contacto"
              data-testid="mobile-nav-cta"
              onClick={() => setOpen(false)}
              className="mt-3 bg-[#203864] text-white text-center py-3 font-medium"
            >
              Cotizar ahora
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
